import { getCaseRolesFromUserRoleStrings } from "./CaseRoles";
export class UserAuthService {
    constructor() {
        this._upn = "";
        this._apiToken = "";
        this._accessToken = "";
        this._displayName = "";
        this._roles = [];
        this._experimentalFeatures = [];
    }
    initialise(params) {
        const { upn, apiToken, displayName, roles, accessToken, experimentalFeatures } = params;
        this._upn = upn;
        this._apiToken = apiToken;
        this._accessToken = accessToken;
        this._displayName = displayName;
        this._roles = getCaseRolesFromUserRoleStrings(roles);
        this._experimentalFeatures = experimentalFeatures;
    }
    attachAuth(opts = {}) {
        if (!this._apiToken) {
            console.warn("Making a service call with a service that uses UserAuthService, but UserAuthService has not been initialised with a token");
            return;
        }
        opts.headers = Object.assign(Object.assign({}, opts.headers), { Authorization: `Bearer ${this._apiToken}` });
    }
    getAccessToken() {
        return this._accessToken;
    }
    getApiToken() {
        return this._apiToken;
    }
    getUpn() {
        return this._upn;
    }
    getDisplayName() {
        return this._displayName;
    }
    getRoles() {
        return [...this._roles];
    }
    getExperimentalFeatures() {
        return this._experimentalFeatures;
    }
}
// export a singleton
export const userAuthService = new UserAuthService();
